import React from 'react';
import './introducao.css';
import Footer from '../../components/footer/Footer';
import AudioPlayerSimple from '../../components/audioplayer/AudioPlayerSimple';

const Introducao = () => {
  const iniciarQuiz = () => {
    window.location.href = '/quiz';
  };

  return (
    <>
      <div className="introducao-container">
        <img
          src="/assets/logo1.png"
          alt="Logo NutriFácil"
          className="introducao-logo"
        />

        <div className="introducao-box">
          <h1 className="introducao-titulo">
            🍏 Boas-vindas ao <span className="marca">NutriFácil</span>
          </h1>

          {/* PLAYER DE ÁUDIO */}
          <AudioPlayerSimple
            audioSrc="/introducao-v2.mp3"
            avatarSrc="/avatar.png"
          />

          <p className="introducao-texto">
  Vamos entender um pouco sobre você para calcular uma{' '}
  <strong>estimativa diária de calorias</strong> e ajudar no acompanhamento da
  sua alimentação.
</p>


          

          <p className="introducao-pergunta">
            <i className="fas fa-hand-point-right"></i> Vamos começar?
          </p>

          <button className="btn-comecar" onClick={iniciarQuiz}>
            <i className="fas fa-play"></i> Começar
          </button>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Introducao;
